import React from "react";
import { useTranslation } from "react-i18next";

import CartIcon from "../../assets/images/CartIcon";
import CartBadge from "../CartBadge";
import "./GoToCartButton.scss";

interface GoToCartButtonProps {
	onClick: () => void;
	className?: string;
	cartCount?: number;
}

const GoToCartButton: React.FC<GoToCartButtonProps> = ({ onClick, className, cartCount = 0 }) => {
	const { t } = useTranslation();

	return (
		<button className={`GoToCartButton ${className || ""}`} onClick={onClick}>
			<CartIcon />
			<span className="GoToCartText">
				<span className="CartTitle">{t("Cart.title")}</span>
				<CartBadge totalQuantity={cartCount} className="GoToCartBadge" />
				<span className="GoToCartArrow">&gt;</span>
			</span>
		</button>
	);
};

export default GoToCartButton;
